@if (rules().length > 0) {
  <div class="progress-outer password-meter" [class.mobile]="inMobile">
    <span>{{ 'passwort_meter.text.description_rules' | translate }}</span>
    <ul>
      @for (rule of rules(); track rule) {
        <li class="password-meter__item" [class.match-rule]="isRuleMatched(rule)">
          @if (isByValuePolicy(rule)) {
            @switch (rule.name) {
              @case ('minimumLength') {
                {{ getPasswordPolicyTranslationKey(rule.name) | translate: { min: rule.value } }}
              }
              @case ('maximumLength') {
                {{ getPasswordPolicyTranslationKey(rule.name) | translate: { max: rule.value } }}
              }
              @default {
                {{ getPasswordPolicyTranslationKey(rule.name) | translate }}
              }
            }
          } @else {
            {{ getPasswordPolicyTranslationKey(rule.name) | translate }}
          }
        </li>
      }
    </ul>
  </div>
}
